export default "__VITE_ASSET__fqXOxhkB__"